import { IModel, IAttribute } from './../base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { IPrivateEndpointCompatible } from 'shell-models-lib';
import { Constants } from 'app/shared/shared-constants';

@Metamodel.model({
    name: adfModelTypeMap.cosmosMongo.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.CosmosDbMongoApi_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.CosmosDbMongoApi_DisplayText)
    ]
})
export class AzureCosmosDbMongoDbApiLinkedService extends LinkedService implements IPrivateEndpointCompatible {

    public static readonly MODEL: IModel;
    public static readonly ACCOUNT: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ConnectionString
    })
    public connectionString: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName
    })
    public databaseName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerVersion
    })
    public isServerVersionAbove32?: boolean = false;

    @Metamodel.attribute({
        display: stringResources.ModelName_AzureCosmosAccountName,
        association: 'ACCOUNT',
        templatable: true
    })
    public account?: string;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    private _accountResourceID: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        let resourceName = '';
        let connectionString = this.connectionString;
        // if connectionString has been marked, retrieve it back from cachedResource
        if (connectionString === Constants.maskedCredential) {
            connectionString = this.cachedResource?.properties?.typeProperties?.connectionString;
        }
        // It might be a secure string object
        if (typeof connectionString === 'string' && connectionString && connectionString.toLowerCase().startsWith('mongodb://')) {
            resourceName = connectionString.substr(10).split(':')[0];
        }
        if (!resourceName || this._accountResourceID && !this._accountResourceID.endsWith('/' + resourceName)) {
            this._accountResourceID = undefined;
        }
        return {
            id: this._accountResourceID,
            name: resourceName
        };
    }

    public setPEResourceID(id: string): void {
        this._accountResourceID = id;
    }
}
